export default __webpack_public_path__ + "static/product-presentation-8db17f0c3c630307d518a742f0ab374e.png";